// removed by extract-text-webpack-plugin
module.exports = {"button":"ArrowLink__button___34YzG","arrow":"ArrowLink__arrow___30dWK","white":"ArrowLink__white___308vV"};


//////////////////
// WEBPACK FOOTER
// ./src/Rist/modules/ArrowLink/ArrowLink.css
// module id = 737
// module chunks = 0